<template>
  <el-dialog
      :model-value="props.visible"
      title="确认授权"
      width="550"
      top="6vh"
      destroy-on-close
      :close-on-click-modal="false"
      @open="onOpen"
      @closed="closedModal"
  >
    <div v-loading="pageLoading">
      <div style="max-height: calc(80vh - 100px);overflow-y: auto;">
        <el-form :model="formData" ref="formRef" :rules="{}" :inline="true" label-width="150px">
          <el-form-item label="统一社会信用代码/纳税人识别号">
            <el-input
                model-value="91110104533585261H"
                placeholder="请输入"
                disabled
                style="width: 330px"
                maxlength="30"
                clearable
            />
          </el-form-item>

          <el-form-item
              style="margin-top: 30px;"
              label="纳税人名称">
            <el-input
                model-value="北京仁和服饰有限公司"
                placeholder="请输入"
                disabled
                style="width: 330px"
                maxlength="30"
                clearable
            />
          </el-form-item>

          <el-form-item
              style="margin-top: 30px;"
              label="身份类型"
              prop="roleType">
            <el-select
                v-model="formData.roleType"
                placeholder=""
                clearable
                disabled
                style="width: 330px"
            >
              <el-option label="办税员" value="办税员"/>
              <el-option label="开票员" value="开票员"/>
              <el-option label="管理员" value="管理员"/>
            </el-select>
          </el-form-item>

        </el-form>
      </div>

      <div class="my-footer">
        <el-button @click="emit('update:visible', false)">取消</el-button>
        <el-button type="primary" style="margin-right: 15px;" @click="onConfirm">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {ElMessage} from "element-plus";

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  currentRow: {
    type: Object,
    default: () => {
    }
  },
})

const pageLoading = ref(false)
const formData = ref({})

function onOpen() {
  formData.value = JSON.parse(JSON.stringify(props.currentRow))
}

const formRef = ref()

const emit = defineEmits(['update:visible', 'confirm'])

async function onConfirm() {
  emit('confirm')
  emit('update:visible', false)
}

function closedModal() {
  emit('update:visible', false)
  formData.value = {}
}
</script>

<style scoped lang="scss">
.my-footer {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 30px;
}
</style>
